// extracted by mini-css-extract-plugin
export default {"resendContainer":"resend_resendContainer__oPPxG","resendBtn":"resend_resendBtn__qVHEm","resendIcon":"resend_resendIcon__liYgP"};